import { render, staticRenderFns } from "./d-book-activity-feed.vue?vue&type=template&id=7131d341&scoped=true&"
import script from "./d-book-activity-feed.vue?vue&type=script&lang=js&"
export * from "./d-book-activity-feed.vue?vue&type=script&lang=js&"
import style0 from "./d-book-activity-feed.vue?vue&type=style&index=0&id=7131d341&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7131d341",
  null
  
)

export default component.exports